import React, { useState } from 'react';
import csv from '../../img/csv-icon.png';
import excel from '../../img/excel-icon.png';
import pdf from '../../img/pdf-icon.png';
import { useParams } from "react-router";
import { services } from '../../api';

const mR10 = {
    marginRight: "5px"
}

const ExportButtons = ({ isArchive, reportId }) => {
    const params = useParams();
    const [isDownloading, setIsDownloading] = useState(false);
    const exportHandler = async (key) => {
        setIsDownloading(true)
        let exportPayload = {
            file_type: key,
            tab: params.type === "customerfacilityfault" ? "cff" : params.type === "customertrainfault" ? "ctf" : "cs",
            is_archive: isArchive ? isArchive : 0,
            ID: params.id ? params.id : '',
            reportId: reportId ? reportId : ""
        }

        let url = `export?tab=${exportPayload.tab}&file_type=${exportPayload.file_type}&is_archive=${exportPayload.is_archive}&ID=${exportPayload.ID}&report_id=${exportPayload.reportId}`;
        let res = await services.ServiceMethod(url, 'get');
        const linkSource = `data:application/${key};base64,${res && res.file_bin}`;
        const downloadLink = document.createElement("a");
        const fileName = res ? res.file_name : "";
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setIsDownloading(false);
    }

    return (
        <>
            <span className="export-text"> Export to</span>
            {isDownloading && <span className="text-danger downloading-file">Downloading</span>}
            <a onClick={() => exportHandler("csv")}><img src={csv} style={mR10} /></a>
            <a onClick={() => exportHandler("xlsx")}><img src={excel} style={mR10} /></a>
            <a onClick={() => exportHandler("pdf")}><img src={pdf} style={mR10} /></a>
        </>
    )
}

export default ExportButtons